import type { FC, ReactNode } from 'react'

import { SectionHeading } from '@/components/generals/section-heading'
import { whyChooseUs } from '@/constants/content'

export const WhyChoose: FC = (): ReactNode => {
    return (
        <section id='why-choose-us' aria-labelledby='why-title' className='bg-ivory py-24 lg:py-32'>
            <div className='mx-auto max-w-7xl px-6'>
                <SectionHeading
                    eyebrow='Why choose us'
                    titleId='why-title'
                    align='center'
                    title={(
                        <>
                            Why families and brands choose
                            {' '}
                            <em className='text-crimson'>Guju Events</em>
                        </>
                    )}
                    description='Big ideas are easy. Making them happen on the day, on time and on budget is where we come in.'
                />

                <div className='mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4'>
                    {whyChooseUs.map(({ icon: Icon, title, text }, index) => (
                        <div
                            key={title}
                            className='group relative overflow-hidden rounded-3xl border border-ink/8 bg-white p-7 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(27,18,25,0.4)]'
                        >
                            <span aria-hidden='true' className='absolute top-6 right-7 font-heading text-5xl text-ink/8 transition-colors group-hover:text-crimson/15'>
                                {String(index + 1).padStart(2, '0')}
                            </span>

                            <span className='inline-flex size-12 items-center justify-center rounded-2xl bg-night text-gold transition-colors duration-500 group-hover:bg-crimson group-hover:text-white'>
                                <Icon className='size-5' aria-hidden='true' />
                            </span>

                            <h3 className='mt-8 font-heading text-2xl leading-tight text-ink'>
                                {title}
                            </h3>

                            <p className='mt-3 text-sm leading-relaxed text-muted-foreground'>
                                {text}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
